import { Component, OnDestroy, ViewChild } from '@angular/core';
import { SalesService } from '../../sales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../../../../services/common/rest.service';
import { CommonService } from '../../../../services/common/common.service';
declare const $: any
import { DatePipe } from '@angular/common';
import { ReceiptAddComponent } from './receipt-add/receipt-add.component';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { BanksService } from '../../../../services/common/banks.service';
import { UserService } from '../../../../services/common/user.service';
import { UserSubType } from '../../../../../appconfig';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrl: './receipt.component.scss'
})

export class ReceiptComponent implements OnDestroy {
  @ViewChild(ReceiptAddComponent) payment!: ReceiptAddComponent;

  bankList: any;
  clientList: any = true;
  collectedByList: any;
  paymentModeList: any;
  projectBankList: any;
  filterTerm!: any;
  gridOptions: any;
  recordList!: any[];
  isDocument: boolean = false;
  navigationId: any;
  showOverlay: boolean = false;
  showClient: boolean = false;
  dropdownMenu: any;
  addressProof = true;
  ActionList: boolean = false;
  projectId: any = null;
  siteId: any = null;
  showaddUpdateModal: boolean = false;
  initials = [];
  frameworkComponents: any;
  currentSelectedRecord: any
  paymentTransactionImage: any;
  bookingId: any = null;
  paymentId: any = 0;
  context: string = '';
  private destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private router: Router, public saleservice: SalesService,
    private api: RestService, public commonService: CommonService,
    private banksService: BanksService, private userService: UserService) {
  }

  ngOnInit() {
    this.bookingId = this.route.snapshot.paramMap.get("bookingId")!;
    this.paymentId = this.route.snapshot.paramMap.get("paymentId")!;

    this.setSiteId();
    this.getPaymentRequiredListData();
    $("#banksN").attr('disabled', 'disabled');
  }

  getPaymentRequiredListData() {

    const selectedProject: any = JSON.parse(this.commonService.getValueFromLocalStorage("selectedProject")!);

    if (selectedProject) {
      forkJoin([this.saleservice.getPaymentTypeMode(), this.banksService.getProjectBankList(selectedProject?.accountId), this.banksService.getBankData()
        , this.userService.getFilterUser(null, null, UserSubType.Client), this.userService.getFilterUser(null, null, UserSubType.User)
      ]).subscribe(([paymentModeList, projectBankList, bankList, clientList, collectedByList]) => {
        this.paymentModeList = paymentModeList?.result;
        this.projectBankList = projectBankList?.result;
        this.bankList = bankList?.result;
        this.clientList = clientList?.result;
        this.collectedByList = collectedByList?.result;
        this.getDataOnProjectLoad();
      })
    }
  }
  /**
   * updating data on behalf of siteId
   */
  setSiteId() {
    this.siteId = this.commonService.localStorageSiteId;
  }

  /**
   * populating data of payment on behalf of project changed
   */
  getDataOnProjectLoad() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe(project => {
        if (project) {
          this.projectId = project.accountId;
          this.getAllPayments()
        }
      });
  }

  // Redirecting from Payment Action (Booking) to booking page using bookingID
  routeBookingPage(data: any) {
    this.router.navigate(['sales/booking/' + data.bookingId])
  }

  //getting payment data on behalf of navigations
  setPaymentData() {
    this.route.params.subscribe(params => {
      this.navigationId = params['id']
      if (!this.navigationId) {
        this.getAllPayments()
      }
      else if (this.navigationId) {
        this.getPaymentDataByBookingId(this.navigationId);
      }
    })
  }

  // Redirecting from Payment Action (Document) to Document page
  routeDocumentPage() {
    this.isDocument = true
    $("#adaharId").attr('disabled', 'disabled');
    $("#panId").attr('disabled', 'disabled');
    $("#bankName").attr('disabled', 'disabled');
    $("#bankAccountNo").attr('disabled', 'disabled');
    $("#ifscCode").attr('disabled', 'disabled');
    $("#bankAccountName").attr('disabled', 'disabled');
    $("#chequeId").attr('disabled', 'disabled');
    $("#voterId").attr('disabled', 'disabled');
    $("#addressProofNo").attr('disabled', 'disabled');
    this.
      addressProof = true
  }

  /**
    *
    * @param {any} paymentId Redirecting from payment action trigerred option using paymentId
    */
  dropdownActonMenu(paymentId: any) {
    this.dropdownMenu = document.getElementById("actionMenuContent" + paymentId);
    this.dropdownMenu?.classList.toggle("dropdownActionMenu");
    this.ActionList = !this.ActionList;
  }


  /**
   * When user will select client name on payment model then it will get booking of selected client
   * @param id
   */
  getClientBookings(id: any) {
    this.api.getData('booking?customerId=' + id).subscribe(res => {
      if (res) {
        this.clientList = res.result.map((data: any) => {
          data.product = data.unitCategoryDetail.name;
          return data;
        });
        if (this.clientList > 1) {
          this.showClient = true
        } else {
          this.showClient = true;
        }
      }
    })
  }

  /**
   * get payment details
   * @param isSpinnerVisisble For loader
   *
   */
  getAllPayments() {
    var datePipe = new DatePipe('en-US');

    //Get payment data
    if (this.projectId) {
      this.saleservice.getFilterPayments(this.bookingId, this.projectId, this.siteId).subscribe((res: any) => {
        if (res) {
          this.recordList = res.result.map((data: any) => {

            data.paymentDate = new Date(data.paymentDate);
            let date = datePipe.transform(data.paymentDate, 'dd-MMM-yyyy');
            data.paymentDate = date;
            let formattedAmount: string = data.amount.toLocaleString('en-IN');
            data.amount = formattedAmount;
            data.transactionNumber = data.transactionNumber;
            data.originalAmount = formattedAmount.replaceAll(',', '');
            data.unitName = data?.unitDescriptionDetail?.name
            data.paymentType = data?.paymentModeDetail?.paymentModeName;
            if (data.sourceDetail) {
              data.sourceDetail = (data.sourceDetail.nameInitialsName ? data.sourceDetail.nameInitialsName + '. ' : "") + data.sourceDetail?.firstName + ' ' + data.sourceDetail?.lastName
            }
            if (data.clientDetail) {
              data.clientName = (data.clientDetail.nameInitialsName ? data.clientDetail.nameInitialsName + '. ' : "") + data.clientDetail?.firstName + ' ' + data.clientDetail?.lastName;
            }
            return data;
          });
          if (this.paymentId != null && this.paymentId != "undefined") {
            let filterPlanObject = {
              showaddUpdateModal: true,
              currentSelectedRecord: this.recordList.find((filter: any) => filter.id == parseInt(this.paymentId)),
              isSubmitted: false
            };
            this.changeAddUpdateModelState(filterPlanObject);
          }
        }
        else {
          this.recordList = [];
        }
      })
    }
  }

  /**
   * Returns the
   * @param {any} bookingId getting payment details by bookingId
   */
  getPaymentDataByBookingId(bookingId: any) {
    var datePipe = new DatePipe('en-US');
    this.saleservice.getFilterPayments(bookingId, null, 1).subscribe((res: any) => {
      if (res) {
        this.recordList = res.result.map((data: any) => {

          data.paymentDate = new Date(data.paymentDate);
          let date = datePipe.transform(data.paymentDate, 'dd-MMM-yyyy');
          data.paymentDate = date;
          let formattedAmount: string = data.amount.toLocaleString('en-IN');
          data.amount = formattedAmount;
          data.transactionNumber = data.transactionNumber;
          data.originalAmount = formattedAmount.replaceAll(',', '');
          data.paymentType = data.paymentModeDetail.paymentModeName;
          if (data.sourceDetail) {
            data.sourceDetail = (data.sourceDetail.nameInitialsName ? data.sourceDetail.nameInitialsName + '. ' : "") + data.sourceDetail?.firstName + ' ' + data.sourceDetail?.lastName
          }
          if (data.clientDetail) {
            data.clientName = (data.clientDetail.nameInitialsName ? data.clientDetail.nameInitialsName + '. ' : "") + data.clientDetail?.firstName + ' ' + data.clientDetail?.lastName;
          }
          return data;
        });
      }
      else {
        this.recordList = [];
      }
    })
  }

  /**
  * Click Close Model Form
  */
  closePaymentDialogue() {
  }

  /**
   * Open And Close Payment Modal
   */
  changeAddUpdateModelState(paymentModal: any) {
    if (paymentModal.showaddUpdateModal) {
      this.currentSelectedRecord = {
        "currentRecord": paymentModal?.currentSelectedRecord,
        "paymentModeList": this.paymentModeList,
        "projectBankList": this.projectBankList,
        "bankList": this.bankList,
        "clientList": this.clientList,
        "collectedByList": this.collectedByList,
        "showaddUpdateModal": true,
      }
    }
    if (paymentModal?.context === "Edit") {
      this.context = paymentModal?.context;
    } else {
      this.context = "Add"
    }
    this.showaddUpdateModal = paymentModal?.showaddUpdateModal;
    if (paymentModal.isSubmitted) {
      if ((this.bookingId != null && this.bookingId != "undefined") || (this.paymentId != null && this.paymentId != "undefined")) {
        this.router.navigate(['sales/payment']);
      } else {
        this.getDataOnProjectLoad();
      }
    }
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}



